import React, { useState, useEffect } from 'react'

import { questionSaveModify, SaveAnswer } from "../../../reducers/survey_question"
import { questionsetAnswerSaved } from "../../../reducers/survey_questionset"




const ClearQuestion = (val)=>{
    
    if (val.endsWith(' RACE DONT WANT TO SAY')){ return true}
    else if (val.endsWith(' CHOOSE NOT TO ANSWER')) {return true}
    else if (val.endsWith(' HOUSING PROBLEMS NONE')) {return true}
    return  false
}

const RaceQuestionSet = (val)=>{
    if (val.endsWith(' RACE')) {return true}
    else if (val.endsWith(' ETHNICITY')) {return true}
    else if (val.endsWith(' HOUSING PROBLEMS')) {return true}
    return false
}
function AdditionalSaveAnswerLogic(props) {
   

    const handleRaceCheckbox = () => {
        props.dispatch(SaveAnswer({
            auth: props.currentUser.AuthToken,
            response: props.responseGuid,
            questionID: props.Question.QuestionId,
            value: props.value
        }))

        props.dispatch(questionSaveModify({ QuestionId: props.Question.QuestionId, value: props.value }))
        if (
            ClearQuestion(props.Question.QuestionName) 
            && props.value === '42'
        ) {
            // clear all race values
            for (var q = 0; q < props.Questions.length; q++) {
                if (props.Questions[q].QuestionId !== props.Question.QuestionId) {
                    props.dispatch(SaveAnswer({
                        auth: props.currentUser.AuthToken,
                        response: props.responseGuid,
                        questionID: props.Questions[q].QuestionId,
                        value: '-1'
                    })
                    )
                    props.dispatch(questionSaveModify({ QuestionId: props.Questions[q].QuestionId, value: '-1' }))
                }
            }
        }
        else {
            if (
                !ClearQuestion(props.Question.QuestionName)
                && props.value === '42'
            ) {
                let unMarkQuestions = props.Questions.filter((a) => { return ClearQuestion(a.QuestionName) })
                // clear all race values
                for (var q = 0; q < unMarkQuestions.length; q++) {
                    if (unMarkQuestions[q].QuestionId !== props.Question.QuestionId) {
                        props.dispatch(SaveAnswer({
                            auth: props.currentUser.AuthToken,
                            response: props.responseGuid,
                            questionID: unMarkQuestions[q].QuestionId,
                            value: '-1'
                        })
                        )
                        props.dispatch(questionSaveModify({ QuestionId: unMarkQuestions[q].QuestionId, value: '-1' }))
                    }
                }
            }
        }
        props.dispatch(questionsetAnswerSaved({ QuestionSetId: props.QuestionSet.QuestionSetId }))


    }

    
    if (props.QuestionSet && RaceQuestionSet(props.QuestionSet.QuestionSetName) ) {
        handleRaceCheckbox(props)
    }
    return true
}


export default AdditionalSaveAnswerLogic